/* eslint-disable import/no-default-export */
import React from 'react';

const ArchivedIcon = (props) => (
  <svg width={12} height={12} viewBox="0 0 12 12" {...props}>
    <g fill={props.color || 'currentColor'} fillRule="evenodd">
      <path d="M.805 3.755v7.031c0 .67.546 1.214 1.218 1.214h8.084c.673 0 1.218-.544 1.218-1.214v-7.03H.805zM9.818 5.25v4.667a.574.574 0 0 1-.565.583h-6.41a.574.574 0 0 1-.566-.583V5.25h7.541zm-6.032 1.5H8.29a.74.74 0 0 1 .73.75.74.74 0 0 1-.73.75H3.786a.74.74 0 0 1-.73-.75.74.74 0 0 1 .73-.75z" />
      <path
        d="M1.673 2.99l9-1.5a.75.75 0 1 0-.246-1.48l-9 1.5a.75.75 0 1 0 .246 1.48z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default ArchivedIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/ArchivedIcon.js